var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,3C6.3,2.6,5.3,2.6,4.6,3l9.1,8.4l3.1-3.1L7,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,3.9C3.4,4.2,3.3,4.6,3.3,5.1v15.2c0,0.4,0.1,0.8,0.3,1.2l9.2-9.2L3.7,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,10.6L17.9,9l-3.3,3.3l4,3.7l2.2-1.2c0.8-0.4,1.3-1.2,1.3-2.1C22,11.8,21.6,11,20.8,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,13.1l-9.2,9.2c0.4,0.2,0.8,0.3,1.3,0.3c0.4,0,0.9-0.1,1.2-0.3l10.4-5.8L13.7,13.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogleplay);
export default __webpack_public_path__ + "static/media/logo_googleplay.3af997d245343e1655619fe47678d870.svg";
export { ForwardRef as ReactComponent };